import { render, staticRenderFns } from "./VistaPrincipal.vue?vue&type=template&id=ef987cba&"
import script from "./VistaPrincipal.vue?vue&type=script&lang=js&"
export * from "./VistaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports